import React from 'react';

import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import { useDialog } from '../../utils/dialog';
import { useAPI } from '../../utils/api';

const ForgotPasswordPage = () => {
  const dialog = useDialog();
  const api = useAPI();

  const requestResetPassword = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);

    const accountCode = data.get('accountNumber');
    const email = data.get('email');

    if (!accountCode || !email) {
      dialog.openAlert({ message: '請輸入正確的資訊以進行操作' });
    } else {
      const parameters = {
        accountCode,
        email,
        browserInfo: navigator.userAgent,
      };

      api
        .forgetPassword(parameters)
        .then(() => {
          dialog.openAlert({ message: '忘記密碼驗證信已寄出。' });
        })
        .catch(() => {});
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          忘記密碼
        </Typography>
        <Box
          component="form"
          onSubmit={requestResetPassword}
          noValidate
          sx={{ mt: 1 }}
        >
          <TextField
            margin="normal"
            required
            fullWidth
            id="accountNumber"
            label="會員帳號"
            name="accountNumber"
            helperText="請輸入當初註冊的會員編號"
            autoFocus
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="email"
            label="Email"
            type="email"
            id="email"
            helperText="請輸入當初註冊的電子郵件"
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="success"
            sx={{ mt: 3, mb: 3, color: 'white' }}
          >
            確認送出
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default ForgotPasswordPage;
